var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app","classFULL_WIDTH":"container-fluid"}},[_c('div',{attrs:{"id":"nav"}}),_c('GMS'),_c('router-view'),_c('main-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }